.status-icons {
  display: flex;
  flex-direction: row;
  gap: 2ch;
}

.status-icon-component {
  display: flex;
  gap: 1ch;
  align-items: center;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9Db21jYXN0LXhmaW5pdHl4Y2hhbmdlMi9kbGUtd2ViYXBwL3NyYy9jb21wb25lbnRzL1N0YXR1c0ljb25zIiwic291cmNlcyI6WyJTdGF0dXNJY29uLm1vZHVsZS5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0U7RUFDQTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQSIsInNvdXJjZXNDb250ZW50IjpbIi5zdGF0dXMtaWNvbnMge1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogcm93O1xuICBnYXA6IDJjaDtcbn1cblxuLnN0YXR1cy1pY29uLWNvbXBvbmVudCB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGdhcDogMWNoO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xufVxuIl19 */